import { IconButton, SvgIconTypeMap } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";

import { OtpCountdownComponent } from "@zenith/components";
import { SendOtpDTO } from "@zenith/services/user";

export const failureResponseMessage = (Payload: {
  field?: string;
  message1?: string;
  message2?: string;
}) => (
  <span className="ml-2">
    {Payload.message1} {Payload.field ? <strong>{Payload.field}.</strong> : ""}{" "}
    {Payload.message2}
  </span>
);

export const successResponseMessage = (field: string, firstMessage: string) => (
  <span className="ml-2">
    {firstMessage} <strong>{field}</strong>
  </span>
);

export const timerElement = (seconds: number, align: "center" | "start") => (
  <div
    className={`mt-12 flex flex-col items-center justify-center sm:items-${align} sm:justify-${align} space-y-5`}
  >
    <div className="text-base font-normal leading-normal text-neutral-500">
      <OtpCountdownComponent seconds={seconds}></OtpCountdownComponent>
    </div>
  </div>
);

export const iconElement = (
  id: string,
  field: string,
  label: string,
  platformType: SendOtpDTO.platform,
  PlatformIcon: OverridableComponent<SvgIconTypeMap>,
  onClickEvent: (platformType: SendOtpDTO.platform) => void
) => (
  <div className="flex flex-col items-center justify-center">
    <IconButton
      id={id}
      aria-label={field}
      size="large"
      className="hover:bg-gray-300"
      onClick={() => onClickEvent(platformType)}
    >
      <PlatformIcon fontSize="inherit" />
    </IconButton>
    <span className="text-zinc-900">{label}</span>
  </div>
);

export const resendOtpElement = (
  text: string,
  platformType: SendOtpDTO.platform,
  onClickEvent: (platformType: SendOtpDTO.platform) => void
) => (
  <span>
    {text}{" "}
    <span
      className="text-bold cursor-pointer capitalize underline"
      onClick={() => onClickEvent(platformType)}
    >
      Resend OTP
    </span>
  </span>
);
